import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "../components";
import "./BaseLayout.css";
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SidebarContext } from "../context/SidebarContext";
import {
  MdOutlineMenu,
  MdKeyboardArrowDown,
  MdErrorOutline,
  MdArrowDownward,
  MdArrowUpward,
} from "react-icons/md";
import { toast } from "react-toastify";
import { IoIosArrowDropdown, IoMdNotificationsOutline } from "react-icons/io";
import { IoIosArrowDropup } from "react-icons/io";
import {
  adminBalanceData,
  GetAllNotifications,
  GetReadNotifications,
  GetUnreadNotifications,
  refreshTokenApi,
  userBalanceData,
  GetAllActivities,
  GetProviderMonitor
} from "../config/LiveApi";
import { useSelector, useDispatch } from "react-redux";
import userSlice from "../redux/slices/userSlice";
import Card from "./Notification/Card";
import TopDrawer from "./components/TopDrawer";
import socket from "./../socket";
import axios from "axios";
import { useRefreshTokenTimer } from "../hooks/useRefreshTokenTimer";

const { actions } = userSlice;

const formatIstTime = (raw) => {
  if (!raw) return "";
  const m = String(raw).match(
    /(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/
  );
  if (!m) return String(raw).replace(" IST", "");
  const [, y, mon, d, hh, mm] = m;
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];
  let hour = parseInt(hh, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${parseInt(d, 10)} ${months[parseInt(mon, 10) - 1]} ${y}, ${String(
    hour
  ).padStart(2, "0")}:${mm} ${ampm}`;
};

// Backend tags every provider alert with type: 'payin' | 'payout'.
const FLOW_THEME = {
  payin: {
    label: "PAYIN",
    accent: "#1d4ed8",
    badgeBg: "#dbeafe",
    badgeText: "#1e40af",
    Icon: MdArrowDownward,
  },
  payout: {
    label: "PAYOUT",
    accent: "#6d28d9",
    badgeBg: "#ede9fe",
    badgeText: "#5b21b6",
    Icon: MdArrowUpward,
  },
};

const UNKNOWN_FLOW_THEME = {
  label: "UNKNOWN",
  accent: "#4b5563",
  badgeBg: "#f3f4f6",
  badgeText: "#374151",
  Icon: MdErrorOutline,
};

// The payload marks the flow inconsistently: the socket may send `type`, the
// provider-monitor endpoint sends `channel` on payout rows only, and payin rows
// carry no marker at all. Read every signal, then fall back to payin.
const flowOf = (alert) => {
  if (!alert) return null;

  for (const raw of [alert.type, alert.channel, alert.flow]) {
    const v = String(raw ?? "").toLowerCase();
    if (v === "payin" || v === "payout") return v;
  }

  const hints = [alert.reason, alert.key, alert.providerId, alert.title]
    .join(" ")
    .toLowerCase();
  if (hints.includes("payout")) return "payout";

  return "payin";
};

const themeOf = (flow) => FLOW_THEME[flow] || UNKNOWN_FLOW_THEME;

const baseIdOf = (alert) => alert?._baseId ?? alert?.providerId ?? alert?.key ?? "";

// A provider can fail on payin and payout independently, so the flow is part of
// the identity — otherwise one alert silently overwrites the other.
const alertIdentity = (alert) =>
  `${baseIdOf(alert)}::${flowOf(alert) ?? "unknown"}`;

const BaseLayout = () => {
  const remaining = useRefreshTokenTimer();
  // const [showTimerModal, setShowTimerModal] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [allnotifications, setAllNotifications] = useState([]);
  const [allActivities, setAllActivities] = useState([]);

  
  const [showInfoDrawer, setShowInfoDrawer] = useState(false);
  
  const [providerAlerts, setProviderAlerts] = useState([]);
  const [hasNewAlert, setHasNewAlert] = useState(false);
  // "all" | "payin" | "payout"
  const [alertFlowFilter, setAlertFlowFilter] = useState("all");
  // providerId that was just updated — used to briefly highlight its time+count
  const [highlightId, setHighlightId] = useState(null);
  const highlightTimer = useRef(null);

  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showDrop, setshowDrop] = useState(false);
  const [balanceData, setBalanceData] = useState(0);
  const [availablePayout, setAvailablePayout] = useState(0);
  const navigate = useNavigate();
  const { openSidebar } = useContext(SidebarContext);
  const role = useSelector((store) => store.userReducer.role);
  const name = useSelector((store) => store.userReducer.userName);
  const token = useSelector((store) => store.userReducer.token);
  const dispatch = useDispatch();
  const notificationRef = useRef(null);

  
  const roleRef = useRef(role);
  useEffect(() => {
    roleRef.current = role;
  }, [role]);
 

  
  const canSeeDrawer = role === "operation" || role === "super";

 
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  const logout = () => {
    dispatch(actions.logout());
    navigate("/login");
    toast.success("Logged out successfully!");
  };
  const passwordChange = () => {
    navigate("/change-password");
    setshowDrop(false);
  };
  const userBalance = useCallback(async () => {
    if (token) {
      const resp = await userBalanceData(token);
      console.log(resp);
      setBalanceData(resp?.finalBalance);
      setAvailablePayout(resp?.walletBalance);
    }
  }, [token]);

  useEffect(() => {
    if (
      token &&
      (role === "admin" ||
        role === "operation" ||
        role === "mops" ||
        role === "subAdmin")
    ) {
      userBalance();
    }
  }, [role, token, userBalance]);

  useEffect(() => {
    const fetchInitialNotifications = async () => {
      const all = await GetAllNotifications(role);
      setAllNotifications(all);
    };
    if (role !== "admin" && role !== "subAdmin") {
      fetchInitialNotifications();
    }
  }, [role]);
  useEffect(() => {
    const fetchInitialActivities = async () => {
      const all = await GetAllActivities();
      setAllActivities(all);
    };
    if (role !== "admin" && role !== "subAdmin" && role !== "mops") {
      fetchInitialActivities();
    }
  }, [role]);
  useEffect(() => {
    if (role !== "admin" || role !== "mops" || role !== "subAdmin" || role !== "operation") {
      socket.on("notification", async (response) => {
        setAllNotifications((prev) => [response, ...prev]);
        //      if (response.type === "duplicate_webhook" && alertSound.current) {
        //   alertSound.current.play().catch(err => console.log("Sound play error:", err));
        // } else if (response.type === "error_webhook" && alertSoundWebhookError.current) {
        //   alertSoundWebhookError.current.play().catch(err => console.log("Sound play error:", err));
        // }
        // else{
        //   alertSound.current.play().catch(err => console.log("Sound play error:", err));
        // }

        if (showNotifications) {
          try {
            await axios.patch(`/notifications/${response._id}/read`);
            console.log("Notification marked as read:", response._id);
          } catch (err) {
            console.error("Failed to mark new notification as read", err);
          }
        } else {
          setUnreadCount((prev) => prev + 1);
        }
        // if (alertSound.current) {
        //   alertSound.current
        //     .play()
        //     .catch((err) => console.log("Sound play error:", err));
        // }
      });

      return () => {
        socket.off("notification");
      };
    }
  }, [showNotifications]);

  
  useEffect(() => {
    const handleDrawerAlert = (response) => {
      console.log("drawer_alert received:", response, "role:", roleRef.current);

      if (roleRef.current !== "operation" && roleRef.current !== "super") {
        return;
      }

      const incoming = {
        ...response,
        _baseId: response.providerId ?? `${Date.now()}`,
      };
      const key = alertIdentity(incoming);

      setProviderAlerts((prev) => {
        const idx = prev.findIndex((p) => alertIdentity(p) === key);
        const merged = {
          ...(idx >= 0 ? prev[idx] : {}),
          ...incoming,
          _clientId: key,
        };
        const rest = idx >= 0 ? prev.filter((_, i) => i !== idx) : prev;
        return [merged, ...rest].slice(0, 50);
      });

      
      setHighlightId(key);
      if (highlightTimer.current) clearTimeout(highlightTimer.current);
      highlightTimer.current = setTimeout(() => setHighlightId(null), 2500);

      setHasNewAlert(true);
    };

    socket.on("drawer_alert", handleDrawerAlert);
    return () => {
      socket.off("drawer_alert", handleDrawerAlert);
      if (highlightTimer.current) clearTimeout(highlightTimer.current);
    };
  }, []);

  
  useEffect(() => {
    if (!token || !canSeeDrawer) return;

    let cancelled = false;
    (async () => {
      try {
        const records = await GetProviderMonitor();
        if (cancelled || !Array.isArray(records)) return;

        const mapped = records
          .map((r) => {
            const withId = { ...r, _baseId: r.providerId || r.key };
            return {
              ...withId,
              _clientId: alertIdentity(withId),
              // `type` carries the payin/payout flow from the backend — keep it
              // and track the skip state under its own field.
              statusType:
                r.skipped === false ? "provider_failing" : "provider_skipped",
              title: r.title || "Provider Skipped",
              message:
                r.message ||
                `${r.providerName || "A provider"} was skipped — last 10 transactions failed.`,
              failedCount: 10,
            };
          })
          .sort((a, b) =>
            String(b.lastSeenIst || "").localeCompare(String(a.lastSeenIst || ""))
          );

        
        setProviderAlerts((prev) => {
          const seen = new Set(mapped.map(alertIdentity));
          const liveOnly = prev.filter((p) => !seen.has(alertIdentity(p)));
          return [...liveOnly, ...mapped].slice(0, 50);
        });

       
        if (
          !cancelled &&
          mapped.length > 0 &&
          sessionStorage.getItem("openAlertsOnLogin") === "1"
        ) {
          setShowInfoDrawer(true);
        }
      } catch (e) {
        console.log("Failed to load provider monitor:", e?.message);
      } finally {
       
        sessionStorage.removeItem("openAlertsOnLogin");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, canSeeDrawer]);

  const toggleNotifications = async () => {
    const newState = !showNotifications;
    setShowNotifications(newState);

    if (!newState) return; // Only act when opening
    
    try {
     
      const updated = allnotifications.map((n) =>
        !n.read ? { ...n, read: true } : n,
      );
      setAllNotifications(updated);
      setUnreadCount(0);
    } catch (error) {
      console.error("Failed to mark all as read:", error);
    }
  };
  const handleAutoLogout = useCallback(() => {
    dispatch(actions.logout());
    navigate("/login");
    toast.error("Session expired. Please log in again.");
  }, [dispatch, navigate]);

  
  const toggleInfoDrawer = () => {
    setShowInfoDrawer((prev) => {
      const next = !prev;
      if (next) setHasNewAlert(false);
      return next;
    });
  };
  

  // const handleRefreshSession = async () => {
  //   try {
  //     if (showTimer) {
  //       toast.success("Session extended successfully.", { autoClose: 1000 });
  //       setShowTimerModal(false);
  //     }
  //     const refreshToken = store.getState().userReducer.refreshToken;

  //     const res = await refreshTokenApi(refreshToken);

  //     store.dispatch(actions.setItem(["token", res.accessToken]));

  //     if (res.refreshToken) {
  //       store.dispatch(actions.setItem(["refreshToken", res.refreshToken]));
  //     }

  //     const newExpiryTimestamp = Date.now() + Number(res.refreshTokenExpiry);
  //     store.dispatch(
  //       actions.setItem(["refreshTokenExpiry", newExpiryTimestamp])
  //     );

  //     return res.accessToken;
  //   } catch (error) {
  //     store.dispatch(actions.logout());
  //     window.location.href = "/login";
  //     throw error;
  //   }
  // };
  // useEffect(() => {
  //   if (showTimer) {
  //     setShowTimerModal(true);
  //   }
  // }, [showTimer]);

  useEffect(() => {
    if (remaining <= 0 && remaining !== null) {
      // setShowTimerModal(false);
      setShowExpiredModal(true);
    }
  }, [remaining]);

  const payinAlertCount = providerAlerts.filter(
    (a) => flowOf(a) === "payin",
  ).length;
  const payoutAlertCount = providerAlerts.filter(
    (a) => flowOf(a) === "payout",
  ).length;
  const visibleAlerts =
    alertFlowFilter === "all"
      ? providerAlerts
      : providerAlerts.filter((a) => flowOf(a) === alertFlowFilter);

  const alertFlowTabs = [
    { id: "all", label: "All", count: providerAlerts.length, accent: "#b91c1c" },
    {
      id: "payin",
      label: "Payin",
      count: payinAlertCount,
      accent: FLOW_THEME.payin.accent,
    },
    {
      id: "payout",
      label: "Payout",
      count: payoutAlertCount,
      accent: FLOW_THEME.payout.accent,
    },
  ];

  return (
    <main
      className="page-wrapper main-back-pope"
      onClick={() => (showDrop ? setshowDrop(false) : "")}
    >
      <Sidebar allActivities={allActivities} />
      <div className="nav-main" style={{ position: "relative" }}>
        <div className="size-main-nav">
          <div className="user-name">
            <button
              className="sidebar-open-btn-1"
              type="button"
              onClick={openSidebar}
            >
              <MdOutlineMenu size={24} />
            </button>

            <div className="right-hand">
              {(role === "admin" || role === "mops" || role === "subAdmin") && (
                <div data-tour="wallet-balance" className="merch-wallet-balance">
                  Wallet Balance: <span>₹ {availablePayout?.toFixed(2)}</span>
                </div>
              )}
              {(role === "admin" || role === "subAdmin") && (
                <div className="bal-tag">
                  Ledger Balance: <span>₹ {balanceData?.toFixed(2)}</span>
                </div>
              )}

            

              {(role === "super" || role === "operation") && (
                <div
                  className={`notification-icon ${showNotifications ? "active-notification" : ""}`}
                  ref={notificationRef}
                >
                  <div
                    className="notification-icon-inner"
                    onClick={toggleNotifications}
                  >
                    <IoMdNotificationsOutline size={22} className="notification-badge"/>
                    {allnotifications.length > 0 && (
                      <span className="notification-badge">
                        {allnotifications.length >= 11
                          ? "10+"
                          : allnotifications.length}
                      </span>
                    )}
                  </div>
                  {showNotifications && (
                    <Card
                      showNotifications={showNotifications}
                      setShowNotifications={setShowNotifications}
                      setAllNotifications={setAllNotifications}
                      allnotifications={allnotifications}
                    />
                  )}
                </div>
              )}

              <div>
                <p
                  onClick={() => setshowDrop(!showDrop)}
                  className="align-name"
                >
                  {name || "User Name"}
                  {showDrop ? (
                    <IoIosArrowDropup
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                  ) : (
                    <IoIosArrowDropdown
                      style={{ width: "1.2rem", height: "1.2rem" }}
                    />
                  )}
                </p>
                {showDrop && (
                  <div className="userdropdown">
                    <p onClick={passwordChange}>Change Password</p>
                    <p onClick={logout}>Logout</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {canSeeDrawer && (
          <button
            type="button"
            className="drawer-toggle-tab"
            aria-label={showInfoDrawer ? "Close alerts" : "Open alerts"}
            onClick={toggleInfoDrawer}
          >
           
            <span style={{ position: "relative", display: "inline-flex" }}>
              <MdKeyboardArrowDown
                size={20}
                className={`drawer-toggle-chevron ${showInfoDrawer ? "open" : ""}`}
              />
              {hasNewAlert && !showInfoDrawer && (
                <span
                  style={{
                    position: "absolute",
                    top: "-2px",
                    right: "-2px",
                    width: "9px",
                    height: "9px",
                    borderRadius: "50%",
                    background: "#dc3545",
                    boxShadow: "0 0 0 2px #ffffff",
                  }}
                />
              )}
            </span>
          </button>
        )}
      </div>

     
      {canSeeDrawer && (
        <TopDrawer
          open={showInfoDrawer}
          onClose={() => setShowInfoDrawer(false)}
          title={
            providerAlerts.length
              ? `Provider Alerts (${providerAlerts.length})`
              : "Provider Alerts"
          }
        >
          {providerAlerts.length > 0 && (
            <div
              style={{
                display: "flex",
                gap: "8px",
                marginBottom: "14px",
                flexWrap: "wrap",
              }}
            >
              {alertFlowTabs.map((tab) => {
                const active = alertFlowFilter === tab.id;
                return (
                  <button
                    key={tab.id}
                    type="button"
                    onClick={() => setAlertFlowFilter(tab.id)}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: "7px",
                      border: `1px solid ${active ? tab.accent : "#e5e7eb"}`,
                      background: active ? tab.accent : "#ffffff",
                      color: active ? "#ffffff" : "#374151",
                      borderRadius: "999px",
                      padding: "6px 14px",
                      fontSize: "12px",
                      fontWeight: 700,
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                    }}
                  >
                    {tab.label}
                    <span
                      style={{
                        background: active
                          ? "rgba(255,255,255,0.25)"
                          : "#f3f4f6",
                        color: active ? "#ffffff" : "#6b7280",
                        borderRadius: "999px",
                        padding: "0 7px",
                        fontSize: "11px",
                        fontWeight: 700,
                      }}
                    >
                      {tab.count}
                    </span>
                  </button>
                );
              })}
            </div>
          )}

          {visibleAlerts.length === 0 ? (
            <div
              style={{
                textAlign: "center",
                color: "#6b7280",
                padding: "26px 10px",
                fontSize: "14px",
              }}
            >
              {providerAlerts.length === 0
                ? "No alerts right now. Skipped providers will appear here."
                : `No ${alertFlowFilter} alerts right now.`}
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              {visibleAlerts.map((a) => {
                const failed = a.failedCount ?? 10;
                const time = formatIstTime(a.lastSeenIst || a.firstSeenIst);
                const isHot = highlightId && alertIdentity(a) === highlightId;
                const flow = flowOf(a);
                const theme = themeOf(flow);
                const FlowIcon = theme.Icon;

              
                const merchants =
                  Array.isArray(a.merchants) && a.merchants.length
                    ? a.merchants
                    : a.merchantName || a.userId
                    ? [{ merchantName: a.merchantName || a.userId, count: a.count }]
                    : [];

                return (
                  <div
                    key={a._clientId}
                    style={{
                      borderLeft: "4px solid #dc3545",
                      background: isHot ? "#fff7ed" : "#fef2f2",
                      border: isHot ? "1px solid #fdba74" : "1px solid #fde2e2",
                      borderRadius: "12px",
                      padding: "14px 16px",
                      boxShadow: isHot
                        ? "0 0 0 3px rgba(249,115,22,0.25)"
                        : "0 1px 2px rgba(0,0,0,0.04)",
                      transition:
                        "background 0.4s ease, box-shadow 0.4s ease, border-color 0.4s ease",
                    }}
                  >
                    
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flexWrap: "wrap",
                          gap: "8px",
                          color: "#b91c1c",
                          fontWeight: 700,
                          fontSize: "15px",
                        }}
                      >
                        <MdErrorOutline size={18} />
                        <span
                          title={
                            flow
                              ? `${theme.label} provider failure`
                              : "Flow not reported"
                          }
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "11px",
                            fontWeight: 800,
                            letterSpacing: "0.06em",
                            padding: "3px 9px",
                            borderRadius: "6px",
                            color: theme.badgeText,
                            background: theme.badgeBg,
                            border: `1px solid ${theme.accent}33`,
                          }}
                        >
                          <FlowIcon size={13} />
                          {theme.label}
                        </span>
                        {a.orgName && a.providerName
                          ? `${a.orgName} - ${a.providerName}`
                          : a.orgName || a.providerName || "Provider Skipped"}
                        <span
                          style={{
                            fontSize: "10px",
                            fontWeight: 700,
                            textTransform: "uppercase",
                            letterSpacing: "0.03em",
                            padding: "2px 7px",
                            borderRadius: "999px",
                            color: a.skipped === false ? "#92400e" : "#991b1b",
                            background:
                              a.skipped === false ? "#fef3c7" : "#fee2e2",
                          }}
                        >
                          {a.skipped === false ? "In use" : "Skipped"}
                        </span>
                      </div>
                      {time && (
                        <span
                          title="Last updated"
                          style={{
                            fontSize: "11px",
                            fontWeight: isHot ? 700 : 500,
                            color: isHot ? "#c2410c" : "#6b7280",
                            background: isHot ? "#ffedd5" : "transparent",
                            padding: isHot ? "3px 8px" : "3px 0",
                            borderRadius: "999px",
                            whiteSpace: "nowrap",
                            transition: "all 0.4s ease",
                          }}
                        >
                          {isHot ? "Updated · " : ""}
                          {time}
                        </span>
                      )}
                    </div>

                    
                    <p
                      style={{
                        margin: "8px 0 12px",
                        color: "#374151",
                        fontSize: "13px",
                      }}
                    >
                      {a.message ||
                        `${a.providerName || "A provider"} was skipped — last 10 ${
                          flow ? `${flow} ` : ""
                        }transactions failed.`}
                    </p>

                 
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "10px",
                      }}
                    >
                      <div
                        style={{
                          background: "#ffffff",
                          borderRadius: "8px",
                          padding: "8px 10px",
                        }}
                      >
                        <div style={{ fontSize: "11px", color: "#b91c1c" }}>
                          {flow === "payin"
                            ? "Failed payin txns"
                            : flow === "payout"
                            ? "Failed payout txns"
                            : "Failed transactions"}
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: "#b91c1c",
                          }}
                        >
                          {failed}
                        </div>
                      </div>

                      <div
                        style={{
                          background: isHot ? "#ffedd5" : "#ffffff",
                          borderRadius: "8px",
                          padding: "8px 10px",
                          transition: "background 0.4s ease",
                        }}
                      >
                        <div style={{ fontSize: "11px", color: "#6b7280" }}>
                          Total skips today
                        </div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: 700,
                            color: isHot ? "#c2410c" : "#111827",
                          }}
                        >
                          {a.count ?? merchants.length}×
                        </div>
                      </div>
                    </div>

                  
                    {merchants.length > 0 && (
                      <div style={{ marginTop: "12px" }}>
                        <div
                          style={{
                            fontSize: "11px",
                            color: "#6b7280",
                            marginBottom: "6px",
                          }}
                        >
                          Merchants affected ({merchants.length})
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "6px",
                          }}
                        >
                          {merchants.map((m, i) => (
                            <span
                              key={`${m.userId ?? m.merchantName ?? i}`}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px",
                                background: "#ffffff",
                                border: "1px solid #fde2e2",
                                borderRadius: "999px",
                                padding: "4px 10px",
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#374151",
                              }}
                            >
                              {m.merchantName || m.userId || "Unknown"}
                              {m.count ? (
                                <span
                                  style={{
                                    background: "#fee2e2",
                                    color: "#b91c1c",
                                    borderRadius: "999px",
                                    padding: "0 6px",
                                    fontSize: "11px",
                                    fontWeight: 700,
                                  }}
                                >
                                  {m.count}×
                                </span>
                              ) : null}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}

                    
                    {a.firstSeenIst && (
                      <div
                        style={{
                          marginTop: "12px",
                          fontSize: "11px",
                          color: "#9ca3af",
                        }}
                      >
                        First seen: {formatIstTime(a.firstSeenIst)}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
         
        </TopDrawer>
      )}

      {/* {showTimerModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backdropFilter: "blur(10px)",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "28px",
              borderRadius: "14px",
              width: "420px",
              maxWidth: "90%",
              textAlign: "center",
              boxShadow: "0 10px 40px rgba(0,0,0,0.25)",
            }}
          >
            <h2
              style={{
                marginBottom: "10px",
                fontSize: "22px",
                fontWeight: "700",
                color: "#dc3545",
              }}
            >
              Session Expiring Soon
            </h2>

            <p
              style={{
                fontSize: "14px",
                color: "#555",
                marginBottom: "18px",
              }}
            >
              Your session is about to expire. Please extend your session to
              continue without interruption.
            </p>

            <div
              style={{
                background: "#f8d7da",
                color: "#721c24",
                padding: "14px",
                borderRadius: "10px",
                fontSize: "20px",
                fontWeight: "600",
                marginBottom: "20px",
              }}
            >
              {minutes}:{seconds.toString().padStart(2, "0")}
            </div>

            <p
              style={{
                fontSize: "12px",
                color: "#888",
                marginBottom: "20px",
              }}
            >
              If not extended, you will be automatically logged out.
            </p>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "12px",
              }}
            >
              <button
                onClick={handleRefreshSession}
                style={{
                  background: "#dc3545",
                  color: "white",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Extend Session
              </button>

              <button
                onClick={() => setShowTimerModal(false)}
                style={{
                  background: "#6c757d",
                  color: "white",
                  border: "none",
                  padding: "8px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "600",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )} */}
      {showExpiredModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backdropFilter: "blur(12px)",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
          }}
        >
          <div
            style={{
              background: "white",
              padding: "30px",
              borderRadius: "14px",
              width: "400px",
              maxWidth: "90%",
              textAlign: "center",
              boxShadow: "0 10px 40px rgba(0,0,0,0.3)",
            }}
          >
            {/* 🔴 Title */}
            <h2
              style={{
                color: "#dc3545",
                marginBottom: "12px",
                fontSize: "22px",
                fontWeight: "700",
              }}
            >
              ❌ Session Expired
            </h2>

            {/* 📝 Message */}
            <p
              style={{
                color: "#555",
                fontSize: "14px",
                marginBottom: "20px",
              }}
            >
              Your session has expired. Please log in again to continue.
            </p>

            {/* 🔘 Button */}
            <button
              onClick={() => {
                setShowExpiredModal(false);
                handleAutoLogout();
              }}
              style={{
                background: "#dc3545",
                color: "white",
                border: "none",
                padding: "10px 18px",
                borderRadius: "6px",
                cursor: "pointer",
                fontWeight: "600",
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
      <div className="content-wrapper">
        <Outlet />
      </div>
    </main>
  );
};

export default BaseLayout;
